import React from 'react'
export default function RightIcon (props) {
  return (
    <svg t='1568862816385' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2811' width={props.width || 20} height={props.height || 20}><path d='M432.204118 689.99695l-28.995381-26.145473 163.921373-182.232414L403.208736 299.391764l28.995381-26.115797 187.434903 208.345142L432.204118 689.99695z' p-id='2812' fill='#8a8a8a' /></svg>

  )
}
